const { data } = wp;

// Load posts data
export const getPosts = (postType, setPostsData, query) => {
  const getData = () =>
    data.select('core').getEntityRecords('postType', postType, query);

  // Request posts data
  let postList = getData();

  if (postList && Array.isArray(postList)) {
    setPostsData(postList);
  } else {
    const unsubscribe = data.subscribe(() => {
      const resolved =
        !data
          .select('core')
          .isResolving('getEntityRecords', ['postType', postType, query]) &&
        data
          .select('core')
          .hasFinishedResolution('getEntityRecords', [
            'postType',
            postType,
            query,
          ]);
      if (resolved) {
        postList = getData();
        if (postList && Array.isArray(postList)) {
          unsubscribe();
          setPostsData(postList);
        }
      }
    });
  }
};

export const decodeUnicode = (encodedText) => {
  const textArea = document.createElement('textarea');
  textArea.innerHTML = encodedText;
  return textArea.innerText;
};
